import type {ReactElement} from 'react';
import React from 'react';
import {PublishingScreencloudPanel} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/publishing-screencloud-panel/publishing-screencloud-panel';
import {PublishingDisplaiPanel} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/publishing-displai-panel/publishing-displai-panel';
import {PublishingSmartTvPanel} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/publishing-smart-tv-panel/publishing-smart-tv-panel';
import {PublishingSignageLivePanel} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/publishing-signage-live-panel/publishing-signage-live-panel';
import {PublishingFugoPanel} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/publishing-fugo-panel/publishing-fugo-panel';
import {PublishingVizromPanel} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/publishing-vizrom-panel/publishing-vizrom-panel';
import {PublishingYodeckPanel} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/publishing-yodeck-panel/publishing-yodeck-panel';
import {PublishingPosterbookingPanel} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/publishing-posterbooking-panel/publishing-posterbooking-panel';
import {PublishingDripboardsPanel} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/publishing-dripboards-panel/publishing-dripboards-panel';
import {PublishingClearDigitalShoPanel} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/publishing-clear-digital-sho-panel/publishing-clear-digital-sho-panel';
import type {DigitalSignageCompiledSubPanelProps} from './digital-signage-compiled-sub-panel.types';
import {SubFlowType} from './digital-signage-compiled-sub-panel.types';

export function DigitalSignageCompiledSubPanel({...props}: DigitalSignageCompiledSubPanelProps): ReactElement<any> | undefined {
  const {subFlowType, onClose} = props;

  const getPanel = (): ReactElement | undefined => {
    switch (subFlowType) {
      case SubFlowType.RAYDIANT_SUBDISPLAY:
        return <PublishingDisplaiPanel onClose={onClose} />;

      case SubFlowType.SMART_TV_SUBDISPLAY:
        return <PublishingSmartTvPanel onClose={onClose} />;

      case SubFlowType.SCREEN_CLOUD_SUBDISPLAY:
        return <PublishingScreencloudPanel onClose={onClose} />;

      case SubFlowType.SIGNAGELIVE_WIDGET_SUBDISPLAY:
        return <PublishingSignageLivePanel onClose={onClose} />;

      case SubFlowType.POSTERBOOKING_SUBDISPLAY:
        return <PublishingPosterbookingPanel onClose={onClose} />;

      case SubFlowType.FUGO_SUBDISPLAY:
        return <PublishingFugoPanel onClose={onClose} />;

      case SubFlowType.YODECK_SUBDISPLAY:
        return <PublishingYodeckPanel onClose={onClose} />;

      case SubFlowType.VIZROM_SUBDISPLAY:
        return <PublishingVizromPanel onClose={onClose} />;

      case SubFlowType.DRIPBOARDS_SUBDISPLAY:
        return <PublishingDripboardsPanel onClose={onClose} />;

      case SubFlowType.CLEAR_DIGITAL_SHO_SUBDISPLAY:
        return <PublishingClearDigitalShoPanel onClose={onClose} disabled={false} />;

      default:
        return undefined;
    }
  };

  return getPanel();
}
